const resumeUrl = `${process.env.PUBLIC_URL || ""}/armand-mazalan-resume.html`;
const pdfUrl = `${process.env.PUBLIC_URL || ""}/armand-mazalan-resume.pdf`;

function ResumeDownload() {
  return (
    <section id="resume" className="resume-section" data-section="resume" data-testid="resume-download-section">
      <div className="resume-panel">
        <div className="section-kicker"><span>05</span><span>THE PUBLIC VERSION</span></div>
        <div className="resume-copy"><h2 data-testid="resume-download-heading">A concise version<br /><em>for the next room.</em></h2><p data-testid="resume-download-summary">A privacy-safe resume covering the work, tools, and through-line — with personal contact details kept intentionally minimal.</p></div>
        <div className="resume-actions"><a className="resume-action resume-action-primary" href={resumeUrl} download data-testid="resume-html-download"><span>HTML RESUME</span>Download the editable web version <b>↓</b></a><a className="resume-action" href={pdfUrl} target="_blank" rel="noreferrer" data-testid="resume-pdf-download"><span>PDF RESUME</span>Download the print-ready PDF <b>↓</b></a></div>
        <span className="resume-note">PHONE + RESIDENTIAL ADDRESS EXCLUDED / PUBLIC VERSION</span>
      </div>
    </section>
  );
}

export default ResumeDownload;
